
import axios from 'axios';

export const  axios_jeresilie_sendLetter = async (data)=>{
    return await axios.post( `/jeresilie/sendLetter/`,data, {headers: { 'Accept': 'application/json', "Content-Type": "multipart/form-data"} }) ;
}




const myheaders = { 'Accept': 'application/json'}
export const  axios_jeresilie_getCompagniesMotifs = async ()=>{
    return await axios.get( `/jeresilie/getCompagniesMotifs/`, {headers:myheaders}) ;
}